import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api/admin`;

const getAuthHeader = () => {
  const token = localStorage.getItem('admin_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const adminAPI = {
  // Auth
  login: async (username, password) => {
    const response = await axios.post(`${API_BASE}/login`, { username, password });
    if (response.data.token) {
      localStorage.setItem('admin_token', response.data.token);
      localStorage.setItem('admin_user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  logout: async () => {
    try {
      await axios.post(`${API_BASE}/logout`, {}, { headers: getAuthHeader() });
    } finally {
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_user');
    }
  },

  getCurrentUser: async () => {
    const response = await axios.get(`${API_BASE}/me`, { headers: getAuthHeader() });
    return response.data;
  },

  // Dashboard
  getDashboardStats: async () => {
    const response = await axios.get(`${API_BASE}/dashboard/stats`, { headers: getAuthHeader() });
    return response.data;
  },

  // Setup
  setupAdmin: async (userData) => {
    const response = await axios.post(`${API_BASE}/setup`, userData);
    return response.data;
  },

  // Check if logged in
  isAuthenticated: () => {
    return !!localStorage.getItem('admin_token');
  },

  getStoredUser: () => {
    const user = localStorage.getItem('admin_user');
    return user ? JSON.parse(user) : null;
  }
};
